import { TYPES } from '../../common/constants';
import * as client from '../../services/client';
import { fetchSuiteCheckList } from './areas';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const setEasyWalkThroughFormData = payload => ({
  type: TYPES.SET_EASY_WALK_THROUGH_FORM_DATA,
  payload,
});

export const setEasyWalkThroughFormNextStep = () => ({
  type: TYPES.SET_EASY_WALK_THROUGH_FORM_NEXT_STEP,
});

export const setEasyWalkThroughFormPreviousStep = () => ({
  type: TYPES.SET_EASY_WALK_THROUGH_FORM_PREVIOUS_STEP,
});

export const setEasyWalkThroughFormStep = step => ({
  type: TYPES.SET_EASY_WALK_THROUGH_FROM_STEP,
  payload: {
    step,
  },
});

export const exitEasyWalkThroughForm = () => ({
  type: TYPES.EXIT_EASY_WALK_THROUGH_FORM,
});

export const updateWalkthroughChecklist = (params,save) => dispatch => {
  return client.updateWalkthroughChecklist(params).then(
    response => {
      if(response.status === 200 || response.ok){
        response.json().then(
          responsejson => {
            dispatch(fetchSuiteCheckList(params.WalkthroughId))
            if(save){

              toast.success('ⓘ Sub-area has been saved.',{autoClose: 10000,position:'top-center'})
            }else{
              // alert('Check List Updated Successfully!');
            }
            
            // dispatch(updateSubAreaCheckStatus( params.SubAreaId,'Ok'))
           
          }
        )
      }
    }
  )
}

 const updateSubAreaCheckStatus = (subAreaId,status) => dispatch => {
  return client.updateSubAreaCheckStatus(subAreaId,status).then( response => {
    if(response.status === 200 || response.ok){
      response.json().then( responsejson => {
        // alert( 'sub area status updated successfully!')
      })
    }
  })
}


  export const fetchWalkThroughServiceList = (WalkthroughId) => dispatch => {
    return client.fetchWalkThroughServiceList(WalkthroughId).then(response => {
    if(response.status === 200 || response.ok){
      response.json().then(
        responsejson => {
          dispatch(
            setEasyWalkThroughFormData({
              walkThroughServiceRequestListLoading:false,
              reviewWalkThroughServiceRequestListLoading:false,
              walkThroughServiceRequests:responsejson.serviceRequests,
              walkThroughSignatureList:responsejson.walkThroughSignatureList,
              walkthroughChecklistItems: responsejson.walkthroughChecklistItems,
              areaChecklist: responsejson.areaChecklist,
              notes: responsejson.notes ? responsejson.notes : ''
            })
          )
        }
      )
    }
  })
}

export const downloadRequests = (walkthroughId, suiteId) => dispatch => {
  return client.downloadRequests(walkthroughId, suiteId).then(response => {
  })
}

export const downloadPDF = (walkthroughId) => dispatch => {
  return client.downloadPDF(walkthroughId).then( response => {
    if( response.status === 200 || response.ok){
      if(response.status === 204) {
      } else {
        response.json().then(
          responsejson => {
            dispatch(
              setEasyWalkThroughFormData({
                PDFURL:responsejson
              })
            )
          }
       )
      }
    }
  })
}

// export const saveServiceRequest = () => ({
//   type: TYPES.SAVE_SERVICE_REQUEST,
// });

// export const setPropertyWalkThroughFormIsVisible = payload => ({
//   type: TYPES.SET_PROPERTY_WALK_THROUGH_FORM_IS_VISIBLE,
//   payload
// });

// export const saveConfigType = data => dispatch =>{
//   return client.saveConfigType(data).then( response => {
//     if(response.status === 200 || response.ok){
//       response.json().then( responsejson => {
//         dispatch(setPropertyWalkThroughFormData({configTypeSaved:responsejson.data[0]}))
//       })
//     }else{
//       alert('some thing went wrong in saving cofig type')
//     }
//   })
// }
